import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { WidgetRepartitionParClientComponent } from "../../../dashboard/components/widget-repartition-par-client/widget-repartition-par-client.component";
import { TiersFacadeService } from "../../services/tiers/tiers-facade.service";
import { ArticlesInfosFacadeService } from "../../../articles/services/article-infos/article-infos-facade.service";
import { Widget } from "../../../dashboard/models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { CaGroupBy } from "../../../dashboard/models/data.model";
import { repartitionCaFromStats } from "./repartition-ca-from-stats.util";

/**
 * Widget Répartition CA dédié à la page Stats Tiers.
 *
 * Wrappe `vl-widget-repartition-par-client` en le nourrissant avec les
 * statistiques du tiers courant (facturesLignes + lotCosts). Remplace
 * historiquement les deux widgets "Ventes par article" et "Marges par article".
 */
@Component({
  selector: "vl-repartition-ca-tiers",
  standalone: true,
  imports: [WidgetRepartitionParClientComponent],
  host: { class: "widget-component" },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <vl-widget-repartition-par-client
      [data]="data()"
      [widget]="widget()"
      [metadata]="metadata()"
      [hidePeriod]="true"
      [availableGroupBy]="availableGroupBy"
      [customTitle]="'Répartition CA'"
      storageKey="justup-widget-repartition-ca-tiers"
    />
  `,
})
export class RepartitionCaTiersComponent {
  widget = input<Widget>();
  metadata = input<EntityMetadata>();

  private tiersFacade = inject(TiersFacadeService);
  private articleInfosFacade = inject(ArticlesInfosFacadeService);
  private stats = this.tiersFacade.getState().stats;

  /** Sur une page scopée à un seul tiers, "Client" et "Groupe" n'apportent rien. */
  availableGroupBy: CaGroupBy[] = ["byArticle", "byFamille"];

  data = computed(() =>
    repartitionCaFromStats(this.stats(), this.articleInfosFacade),
  );
}
